import L from "leaflet";
import { useMemo } from "react";

export function usePulseIcon() {
  return useMemo(
    () =>
      L.divIcon({
        className: "",                 // on vide la classe par défaut
        html: '<div class="pulse-marker"></div>',
        iconSize: [14, 14],            // même taille que le .pulse-marker
        iconAnchor: [7, 7],            // centre du point = ancre
      }),
    []
  );
}
